<script setup>
defineProps({
    message: {
        type: String,
        required: false,
    },
})
</script>

<template>
    <div v-show="message">
        <p class="rounded-lg bg-red-50/60 p-2 text-sm text-red-500">
            {{ message }}
        </p>
    </div>
</template>
